'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { createComponent } from '../core/create-component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let n = {
    disabled: e$1.bool,
    variant: e$1.oneOf([
        'previous',
        'next'
    ]),
    accessibleText: e$1.string
}, i = new Set(Object.keys(n));
i.delete('disabled');
const PaginationButton = createComponent({
    displayName: 'PaginationButton',
    root: 'a',
    propTypes: n,
    propKeysToRemove: Array.from(i),
    propConfig: {
        derivedProps: (e)=>({
                disabled: e.disabled
            }),
        processProps (e) {
            var { accessibleText: t } = e, r = _object_without_properties(e, [
                "accessibleText"
            ]);
            let { disabled: o, as: n, component: i } = r, c = o && 'button' !== n && 'button' !== i;
            return _object_spread_props(_object_spread({
                'aria-label': null != t ? t : void 0
            }, r), {
                disabled: ('button' === n || 'button' === i) && o,
                as: c && 'span' || n || i || 'a',
                role: 'button'
            });
        },
        classNames (e, { disabled: t }) {
            let { variant: r } = e, o = new Set([
                `swan-pagination-button-${r}`
            ]);
            return t && o.add('swan-pagination-button-disabled'), o;
        },
        wrapChildren (e$1) {
            switch(e$1.variant){
                case 'next':
                    return e.createElement(Icon, {
                        iconType: "chevronRight"
                    });
                case 'previous':
                    return e.createElement(Icon, {
                        iconType: "chevronLeft"
                    });
                default:
                    return e.createElement(e.Fragment, null);
            }
        }
    }
});

export { PaginationButton };
